import React, { useState, useEffect } from 'react';
import { Button, Modal, Form, Alert } from 'react-bootstrap'
import CrudTable from '../table/crudtable'
import { documentationAliasService, customerService } from '../../_services'
import DocumentationAliasForm from './documentationaliasform.component'
import { useTranslation } from "react-i18next";
import moment from 'moment'
import { SERVER_URL } from '../../config';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileImport } from '@fortawesome/free-solid-svg-icons'

function DocumentationAlias() {

	const [showImportModal, setShowImportModal] = useState(false)
	const [customers, setCustomers] = useState([])
	const [selectedCustomer, setSelectedCustomer] = useState(-1)
	const [imports, setImports] = useState([])
	const {t} = useTranslation('common');

	useEffect(() => {
		customerService.getOptions().then(customers => {
            customers.sort((a, b) => a.name.localeCompare(b.name))
            setCustomers(customers)
            if (selectedCustomer === -1 && customers.length > 0) {
                setSelectedCustomer(customers[0].id)
            }
        })
    }, []);

	const initialState = {
		customerId: -1,
		name: '',
		alias: ''
	}

	const columns = [
		{
			dataField: 'customerName',
			text: t('documentationalias.columns.customer'),
			sort: true
		},
		{
			dataField: 'name',
			text: t('documentationalias.columns.name'),
			sort: true
		},
		{
			dataField: 'alias',
			text: t('documentationalias.columns.alias'),
			sort: true
		}
	]

	const onClick = () => {
        setShowImportModal(true)
    }

    const onHide = () => {
		setShowImportModal(false)

		setSelectedCustomer(customers[0].id)
        setImports([])
    }

    const handleCustomerChange = e => {
        setSelectedCustomer(e.target.value)
        imports.forEach(row => {
            row.customerId = e.target.value
        })
    }

    const handleFileChange = e => {
        console.log(e)

        let file = e.target.files[0]

        if (file) {
            const reader = new FileReader()
            reader.addEventListener('load', (event) => {
                var result = reader.result
                var rows = result.split(/\r?\n/)
                var imports = []
                rows.forEach(row => {
                    if (row) {
						var rowSplit = row.split(';')
						if (rowSplit.length == 2) {
							var documentationAlias = {
								customerId: selectedCustomer,
								name: rowSplit[0],
								alias: rowSplit[1]
							}
							imports.push(documentationAlias)
						}
                    }
                })
                setImports(imports)
            });
            reader.readAsText(file)
        }
    }

    const onSubmit = () => {
        console.log('onSubmit')

        let data = {
            list: imports
        }

        documentationAliasService.importCSV(data).then(response => {
            console.log(response)

            onHide()
        })
    }

	return (
		<div>
            <CrudTable
		        service={documentationAliasService}
		        columns={columns}
		        initialState={initialState}
		        form={<DocumentationAliasForm />}
		        sort={{dataField: 'customerName', order: 'asc'}}
		        modalSize="lg"
		        buttons={[<Button
		                key="import"
			            onClick={onClick}
			            title="Importera"
			            color="info"
			            variant="outline-dark"
			            style={{float: 'right', marginRight: 5}}>
			            Importera <FontAwesomeIcon icon={faFileImport}/>
			        </Button>]}
			    urlParams={false}
			/>
			<Modal
				style={{overflow: 'scroll'}}
				size="md"
				show={showImportModal}
				backdrop={showImportModal}
				onShow={() => console.log('onShow')}
				onHide={onHide}
				animation={false}>
				<Modal.Header closeButton>
					<Modal.Title>
						Importera dokumentationsalias
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Form.Label>
		                Kund
	                </Form.Label>
					<Form.Control required as="select" name="selectedCustomer" value={selectedCustomer} onChange={handleCustomerChange}>
	                    { customers.map(customer => (
	                        <option key={customer.id} value={customer.id}>
	                            {customer.name}
	                        </option>
	                    ))}
	                </Form.Control>
	                <Form.Label>
		                Fil
	                </Form.Label>
					<Form.Control required={true} type="file" accept=".csv" name="file" onChange={handleFileChange} />
					<Alert variant="primary" style={{marginTop: 5}}>
		                <b>Kolumner:</b> name;alias
	                </Alert>
					<Form.Label style={{marginTop: 5}}>
		                Nya alias
	                </Form.Label>
	                <div style={{maxHeight: 400, overflowY: 'auto'}}>
		                <table className="table table-bordered">
		                    <thead>
		                        <tr>
		                            <th>
		                                Namn
		                            </th>
		                            <th>
		                                Alias
		                            </th>
		                        </tr>
		                    </thead>
		                    <tbody>
		                        { imports.map((row, index) => {
		                            return <tr key={index}>
			                            <td>
			                                { row.name }
			                            </td>
			                            <td>
			                                { row.alias }
			                            </td>
			                        </tr>
		                        })}
		                    </tbody>
		                </table>
	                </div>
				</Modal.Body>
				<Modal.Footer>
					<Button variant="secondary" onClick={onHide}>
						{t('crudtable.cancel')}
					</Button>
					<Button variant="primary" onClick={onSubmit}>
						{t('crudtable.ok')}
					</Button>
				</Modal.Footer>
			</Modal>
		</div>
    )
}

export default DocumentationAlias;